import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/LoginPage.vue'),
    meta: {
      requiresAuth: false,
      showNavbar: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ForgotPassword.vue'),
    meta: {
      requiresAuth: false,
      showNavbar: false,
    },
  },
  {
    path: '/reset-password/:email/:token',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ResetPassword.vue'),
    meta: {
      requiresAuth: false,
      showNavbar: false,
    },
  },
  {
    path: '/account-setup/:email/:token',
    name: 'AccountSetup',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/AccountSetup.vue'),
    meta: {
      requiresAuth: false,
      showNavbar: false,
    },
  },
  {
    path: '/',
    name: 'PoliciesView',
    component: () => import(/* webpackChunkName: "user" */ '@/views/PoliciesView.vue'),
  },
  {
    path: '/policies/:id',
    name: 'PolicyDetails',
    component: () => import(/* webpackChunkName: "user" */ '@/views/PolicyDetails.vue'),
  },
  {
    path: '/insurees',
    name: 'InsureesView',
    component: () => import(/* webpackChunkName: "user" */ '@/views/InsureesView.vue'),
  },
  {
    path: '/insurees/:id',
    name: 'InsureeDetails',
    component: () => import(/* webpackChunkName: "user" */ '@/views/InsureeDetails.vue'),
  },
  {
    path: '/data',
    name: 'DataAdder',
    component: () => import(/* webpackChunkName: "user" */ '@/views/DataAdder.vue'),
  },
  {
    path: '/faq',
    name: 'FAQsManagement',
    component: () => import(/* webpackChunkName: "user" */ '@/views/FAQsManagement.vue'),
  },
  {
    path: '/contact-details',
    name: 'ContactDetailsManagement',
    component: () => import(/* webpackChunkName: "user" */ '@/views/ContactDetailsManagement.vue'),
  },
  {
    path: '/statistics',
    name: 'StatisticsView',
    component: () => import(/* webpackChunkName: "user" */ '@/views/StatisticsView.vue'),
  },
  {
    path: '/profile',
    name: 'ProfileView',
    component: () => import(/* webpackChunkName: "user" */ '@/views/ProfileView.vue'),
  },
  {
    path: '/logs',
    name: 'LogsView',
    component: () => import(/* webpackChunkName: "system-administrator" */ '@/views/system-administrator/LogsView.vue'),
    meta: {
      scopes: ['system-administrator'],
    },
  },
  {
    path: '/logs/:id',
    name: 'LogsDetails',
    component: () =>
      import(/* webpackChunkName: "system-administrator" */ '@/views/system-administrator/LogsDetails.vue'),
    meta: {
      scopes: ['system-administrator'],
    },
  },

  {
    path: '/scopes',
    name: 'ScopesManagement',
    component: () =>
      import(/* webpackChunkName: "system-administrator" */ '@/views/system-administrator/ScopesManagement.vue'),
    meta: {
      scopes: ['system-administrator'],
    },
  },

  {
    path: '/client-selection',
    name: 'ClientSelection',
    component: () => import(/* webpackChunkName: "user" */ '@/views/ClientSelection.vue'),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/clients',
    name: 'ClientsView',
    component: () =>
      import(/* webpackChunkName: "system-administrator" */ '@/views/system-administrator/ClientsView.vue'),
    meta: {
      scopes: ['system-administrator'],
    },
  },
  {
    path: '/clients/:uuid',
    name: 'ClientDetails',
    component: () =>
      import(/* webpackChunkName: "system-administrator" */ '@/views/system-administrator/ClientDetails.vue'),
    meta: {
      scopes: ['system-administrator'],
    },
  },
  {
    path: '/activity-logs',
    name: 'ActivityLogsView',
    component: () =>
      import(/* webpackChunkName: "system-administrator" */ '@/views/system-administrator/ActivityLogsView.vue'),
    meta: {
      scopes: ['system-administrator'],
    },
  },

  {
    path: '/users',
    name: 'UsersView',
    component: () => import(/* webpackChunkName: "user-management" */ '@/views/user-management/UsersView.vue'),
    meta: {
      scopes: ['user-management'],
    },
  },
  {
    path: '/users/:id',
    name: 'UserDetails',
    component: () => import(/* webpackChunkName: "user-management" */ '@/views/user-management/UserDetails.vue'),
    meta: {
      scopes: ['user-management'],
    },
  },
  {
    path: '/apps',
    name: 'AppsView',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/AppsView.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

export default router;
